module.exports = __webpack_public_path__ + "static/image/service/m/bmart@3x.jpg?4ab49b7d";